import { useApi, useCaller } from '@/hooks/api.hook';
import { setListSidebarAction } from '@/redux/slicers/sidebar.slice';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { sideBarItem } from '@/components/Sidebar/constants';

// Toggle this to use fake data when API is down
const USE_MOCK_DATA = false;
export const useSidebarByRole = () => {
  const api = useApi('');
  const caller = useCaller();
  const dispatch = useDispatch();

  const getSidebarByRole = useCallback(async () => {
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 300));
      dispatch(setListSidebarAction({ data: { navigation: sideBarItem as any } }));
      return;
    }

    const { content, succeeded } = await caller(() => api.get(`/api/v1/users/me/authorization`), {
      loadingKey: 'get-detail-workflow-fulfillment',
    });
    if (succeeded) {
      dispatch(setListSidebarAction({ data: content }));
    }
  }, [caller, api, dispatch]);

  return {
    getSidebarByRole,
  };
};
